<script lang="ts">
  import Button from "$lib/Button.svelte";

  interface Props {
    link?: boolean;
    primary?: boolean;
    defaultStyle?: boolean;
    role?: string | undefined;
    class?: string;
    children?: import("svelte").Snippet;
    onclick?: () => void;
  }

  let {
    link = false,
    primary = false,
    defaultStyle = false,
    role = undefined,
    class: classes = "",
    children,
    onclick,
  }: Props = $props();
</script>

<Button
  summary
  class={`summary-component ${classes}`}
  {link}
  {primary}
  {defaultStyle}
  {role}
  {onclick}
>
  <!-- @migration-task: migrate this slot by hand, `iconStart` is an invalid identifier -->
  {#snippet iconStart()}
    <span class="icon icon-chevron-right"></span>
  {/snippet}

  {@render children?.()}
</Button>

<style lang="postcss">
  :global(.summary-component) {
    justify-content: start;
    text-align: start;
  }

  /* css chevron right */
  .icon-chevron-right {
    --_h: 4px;
    --_rotation: 135deg;
    box-shadow: inset var(--_h) var(--_h);
    display: inline-block;
    width: 1em;
    height: 1em;
    margin-inline-end: 0.5em;
    transform: translate(var(--_x, 0), var(--_y, 0.125em)) rotate(var(--_rotation)) scale(0.75);
    transition: transform 0.25s var(--easing);
    position: relative;
  }

  :global(details[open] > summary.summary-component) .icon-chevron-right {
    --_rotation: 225deg;
    --_x: 0.25em;
    --_y: 0;
  }
</style>
